import { getApiUrl } from '@/utils/utils'
import axios from 'axios'
import { useState } from 'react'
import { CHANNEL } from '@/utils/constants'

export function fetchGrantConsent({ email }) {
  const url = `${getApiUrl()}consent/grant`
  const data = {
    ChannelId: CHANNEL.WEBMOTORS,
    ConsentTypeListId: 13,
    Email: email
  }

  return axios.post(url, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

  export function useFetchGrantConsent(email) {
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState({
      success: false,
      message: '',
      statusCode: null,
    });

    if (!email) return
  
    const fetchConsent = () => {
      setIsLoading(true);
      fetchGrantConsent({ email })
      .then(({ data, status }) => {
          const { Success, Message } = data;  
          setIsLoading(false);
          setResult({ success: Success, message: Message, statusCode: status })
        })
        .catch((error) => {
          console.error(error);
          setIsLoading(false);
          
          const statusCode = error.response ? error.response.status : null;
          setResult({ success: false, message: error.message, statusCode });
        });
    };
  
    return { isLoading, result, fetchConsent };
}
